export default {
    after_scanning_qr: "qr кодты сканерлегеннен кейін",
    application_reason: "Жүгіну себебі",
    are_you_sure_you_want_to_delete_lead: "Өтінімді жойғыңыз келе ме?",
    check_status: "Статусты тексеру",
    click_here: "осы жерге басыңыз",
    connect: "Қосу",
    connection_is_right_can_be_used: "Қосылым дұрыс - пайдалануға болады",
    'crm-form': "CRM-нысан",
    forms: "Нысандар",
    lead: "Өтінім",
    leads: "Өтінімдер",
    not_reached: "Қоңырау шала алмадық",
    site_form: "Нысан",
    stale: "Неликвид",
    telegram: "Telegram",
    telegram_qr_instructions: "Телефоныңызда Telegram параметрлерінде QR кодын оқыңыз",
    thinking: "Ойлануда",
    unpaid_message: "Сіздің аккаунтыңызда төлем мерзімі өтіп кеткен. Балансты толтырыңыз немесе қолдау көрсетіңіз.",
    urgent: "Жедел",
    whatsapp: "Whatsapp",
    whatsapp_qr_instructions: "Телефоныңызда whatsapp баптауларында 'құрылғыны байланыстыру' дегенді таңдап, qr кодын оқыңыз"
}
